"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _gatsbyI18n = require("gatsby-i18n");

var _setupI18next = _interopRequireDefault(require("./setupI18next"));

var withI18next = function withI18next() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Comp) {
    var I18n =
    /*#__PURE__*/
    function (_Component) {
      (0, _inherits2["default"])(I18n, _Component);

      function I18n(props) {
        var _this;

        (0, _classCallCheck2["default"])(this, I18n);
        _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(I18n).call(this, props));
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "activateLng", function () {
          var _this$props = _this.props,
              data = _this$props.data,
              pageContext = _this$props.pageContext;

          if (data && data.locales) {
            data.locales.edges.forEach(function (_ref) {
              var node = _ref.node;
              var lng = node.lng,
                  _node$ns = node.ns,
                  ns = _node$ns === void 0 ? 'messages' : _node$ns,
                  data = node.data;
              var parsedData = JSON.parse(data);

              if (!_this.i18n.hasResourceBundle(lng, 'messages')) {
                _this.i18n.addResources(lng, 'messages', parsedData);
              }
            });
          }

          _this.i18n.changeLanguage(pageContext.lng);
        });
        var _pageContext = props.pageContext;
        _this.i18n = (0, _setupI18next["default"])(_pageContext, _this.activateLng); //console.log('@@@ this.i18n', this.i18n);
        //this.activateLng();

        return _this;
      }

      (0, _createClass2["default"])(I18n, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          if (this.props.pageContext.lng !== prevProps.pageContext.lng) {
            this.activateLng();
          }
        }
      }, {
        key: "render",
        value: function render() {
          return _react["default"].createElement(_reactI18next.I18nextProvider, {
            i18n: this.i18n
          }, _react["default"].createElement(_gatsbyI18n.I18nProvider, this.props.pageContext, _react["default"].createElement(Comp, (0, _extends2["default"])({}, this.props, {
            lng: this.props.pageContext.lng
          }))));
        }
      }]);
      return I18n;
    }(_react.Component);

    return I18n;
  };
};

var _default = withI18next;
exports["default"] = _default;